import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

// material
import { styled } from '@material-ui/core/styles';
import { Box, Divider, Typography, Grid, Paper, TextField, Button, MenuItem, Stack, ListItem, List, ListItemText, ListItemAvatar, Avatar, ListItemButton, Badge } from '@material-ui/core';
// redux
import { useDispatch, useSelector } from '../../../redux/store';

import Autocomplete from '@material-ui/lab/Autocomplete';
//import { getMail } from '../../../redux/slices/mail';
//
import Markdown from '../../Markdown';
import Scrollbar from '../../Scrollbar';
import MailDetailsToolbar from './MailDetailsToolbar';
import MailDetailsReplyInput from './MailDetailsReplyInput';
import MailDetailsAttachments from './MailDetailsAttachments';
import { Form, FormikProvider, useFormik } from 'formik';
// ----------------------------------------------------------------------
import * as Yup from 'yup';
import { useSnackbar } from 'notistack5';
import apiContact from '../../../api/contact';
import apiUser from '../../../api/user';
import { useTranslation } from 'react-i18next';

import useAuth from '../../../hooks/useAuth';
import ListFieldContact from './ListFieldContact';
import { objectID } from '../../../utils/objectID';
import { Fragment } from 'react';
import { motion } from 'framer-motion';
import { newMessageFacebookBySelectedContact, newMessageZaloBySelectedContact } from '../../../redux/slices/chat';
import CallHistory from '../pbx/CallHistory';

const RootStyle = styled('div')({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column'
});

const MarkdownWrapperStyle = styled('div')(({ theme }) => ({
  '& > p': {
    ...theme.typography.body1,
    marginBottom: theme.spacing(2)
  }
}));
const ElementStyle = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(1.5, 3),
  transition: theme.transitions.create('all')
}));

// ----------------------------------------------------------------------
const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 24,
  height: 24,
  border: `1px solid ${theme.palette.background.paper}`,
}));

export default function ContactDetails({ contactSelected, setContactSelected }) {

  const { mailId } = useParams();
  const { user } = useAuth();
  const [listUser, setListUser] = useState([]);
  const dispatch = useDispatch();
  //const mail = useSelector((state) => state.mail.mails.byId[mailId]);
  const { enqueueSnackbar } = useSnackbar();
  const [isChecked, setIsChecked] = useState(false);
  const [fieldContact, setFieldContact] = useState([]);
  const [infoContact, setInfoContact] = useState({});
  const [listChatContact, setListChatContact] = useState(null);
  useEffect(() => {
    const load_info_contact = async () => {
      const res_info_contact = await apiContact.view({ contactId: contactSelected });
      setInfoContact(res_info_contact.data.data);
    }
    const load_users = async () => {
      const res_users = await apiUser.view();
      setListUser(res_users.data.data);
    }
    if (contactSelected) {
      load_info_contact();
      load_users();
    }
  }, [contactSelected]);
  const options = [
    { label: 'Bắt buột', value: 'required' },
  ];

  const { t } = useTranslation();
  const [validation, setValidation] = useState({
    name: Yup.string().required('Họ và tên không được bỏ trống!'),
    //email: Yup.string().required('Email không được bỏ trống!').email(),
    phone: Yup.string().required('Số điện thoại không được bỏ trống!'),
    //text: Yup.string().required('Text không được bỏ trống!'),
    //notes: Yup.string().required('Ghi chú không được bỏ trống!')
  });
  const [initialValues, setInitialValues] = useState({});

  const NewUserSchema = Yup.object().shape(validation);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues || {},
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        console.log(values)
        console.log(infoContact)
        values.id = objectID(infoContact._id)
        const status_eidt = await apiContact.edit(values);
        enqueueSnackbar(t('update_success'), { variant: 'success' });
      } catch (error) {
        enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
      }

    }
  });
  const { errors, values, touched, handleSubmit, resetForm, isSubmitting, setFieldValue, getFieldProps } = formik;
  useEffect(() => {
    const load_field_contact = async () => {
      const res_field_contact = await apiContact.list_field_contact();

      setFieldContact(res_field_contact.data.data);
      var validations = validation;
      var arr_initialValues = {
        name: infoContact.name || '',
        email: infoContact.email || '',
        phone: infoContact.phone || '',
        notes: infoContact.notes || '',
        company: infoContact.company || '',
        address: infoContact.address || '',
        created_by: infoContact.created_by || user.id,
      };
      res_field_contact.data.data.map((item) => {
        console.log(item.field_contact_variable);
        if (item.field_contact_condition.includes('required')) {
          if (item.field_contact_type === "email") {
            validations = { ...validations, [item.field_contact_variable]: Yup.string().email('Invalid email').required(item.field_contact_name + ' không được bỏ trống!') };
          }
          else if (item.field_contact_type === "number") {
            validations = { ...validations, [item.field_contact_variable]: Yup.number('Invalid number').required(item.field_contact_name + ' không được bỏ trống!') };
          } else if (item.field_contact_type === "dateTime") {
            validations = { ...validations, [item.field_contact_variable]: Yup.date('Invalid datetime').required(item.field_contact_name + ' không được bỏ trống!') };
          } else {
            validations = { ...validations, [item.field_contact_variable]: Yup.string().required(item.field_contact_name + ' không được bỏ trống!') };
          }
        }
        arr_initialValues = { ...arr_initialValues, [item.field_contact_variable]: infoContact[item.field_contact_variable] || '' };
      })
      setValidation(validations);
      setInitialValues(arr_initialValues)
    }
    load_field_contact();
  }, [infoContact]);

  const isAttached = true;

  const handleChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const onHandleChangCondition = (e) => {
    setFieldValue("field_contact_condition", e)
  }
  const onChangeUserCreate = (e) => {
    setFieldValue("created_by", e.target.value)

  }

  useEffect(() => {
    const loadListChatRecent = async () => {
      const res_list_chat_recent = await apiContact.find_list_chat({ id: infoContact?.id, uid_zl: infoContact?.uid_zl, uid_fb: infoContact?.uid_fb });
      if (res_list_chat_recent.data.data.length > 0) {
        setListChatContact(res_list_chat_recent.data.data)
      }
    }
    if (Object.keys(infoContact).length > 0) {
      loadListChatRecent();
    }
  }, [infoContact]);
  const onOpenConversation = async (item) => {
    if (item.channel === "facebook") {
      dispatch(newMessageFacebookBySelectedContact(item));
    }
    if (item.channel === "zalo") {
      dispatch(newMessageZaloBySelectedContact(item));
    }
  }
  console.log(listChatContact)
  return (
    <RootStyle>
      <MailDetailsToolbar setContactSelected={setContactSelected} contact={infoContact} />
      <Divider />
      <Scrollbar sx={{ flexGrow: 1 }}>
        <Box sx={{ p: { xs: 2, md: 5 } }}>
          <Typography align="center" variant="h5" gutterBottom>
            Thông tin danh bạ: {infoContact.name}
          </Typography>
          <Scrollbar>
            {Object.keys(initialValues).length !== 0 && <ListFieldContact listUser={listUser} fieldContact={fieldContact} validation={validation} infoContact={infoContact} initialValues={initialValues} />}
            <Paper sx={{ mt: 2 }}>
              <Typography variant='h6'> Lịch sử trò chuyện gần đây</Typography>
              <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                {listChatContact && listChatContact.map((item, index) => {
                  const to_display_name = item.to_display_name ? item.to_display_name : "Người lạ";
                  const from_display_name = item.from_display_name ? item.from_display_name : "Người lạ";
                  return (
                    <Fragment>
                      {index !== 0 && <Divider variant="inset" component="li" />}
                       <ElementStyle>
                        <ListItem onClick={() => onOpenConversation(item)} sx={{ cursor: "pointer" }} alignItems="flex-start">
                          <ListItemAvatar>
                            {item.oa_id &&
                              <Badge
                                overlap="circular"
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                badgeContent={
                                  <SmallAvatar src={item.channel === "zalo" ? "/static/icons/icons8-zalo.svg" : "/static/icons/icons8-facebook.svg"} alt="Channel" />
                                }
                              >
                                <Avatar alt="Remy Sharp" src={item.oa_id === item.from_id ? item.to_avatar : item.from_avatar} />
                              </Badge>
                            }
                            {item.page_id &&
                              <Badge
                                overlap="circular"
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                badgeContent={
                                  <SmallAvatar src={item.channel === "zalo" ? "/static/icons/icons8-zalo.svg" : "/static/icons/icons8-facebook.svg"} alt="Channel" />
                                }
                              >
                                <Avatar alt="Remy Sharp" src={item.page_id === item.from_id ? item.to_avatar : item.from_avatar} />
                              </Badge>
                            }
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Typography
                                variant="body2"
                                color="text.primary"
                              >
                                {item?.oa_id ? (item?.oa_id === item.from_id ? to_display_name + '---' + from_display_name : from_display_name + '---' + to_display_name) : null}
                                {item?.page_id ? (item?.page_id === item.from_id ? to_display_name + '---' + from_display_name : from_display_name + '---' + to_display_name) : null}
                              </Typography>
                            }
                            secondary={
                              <Fragment>
                                <Typography
                                  sx={{ display: 'inline' }}
                                  component="span"
                                  variant="body2"
                                  color="text.primary"
                                >
                                  {item?.oa_id ? (item?.oa_id === item.from_id ? to_display_name : from_display_name) : null}
                                  {item?.page_id ? (item?.page_id === item.from_id ? to_display_name : from_display_name) : null}
                                  :{item.message_short}
                                </Typography>

                              </Fragment>
                            }

                          />
                        </ListItem>
                      </ElementStyle>
                      {/* </Stack> */}
                    </Fragment>)
                })}
              </List>
            </Paper>
            <Paper sx={{ mt: 2 }}>
              <Typography variant='h6'> Lịch sử cuộc gọi gần đây</Typography>
              {infoContact?.phone && <CallHistory phone={infoContact.phone}></CallHistory>}

            </Paper>
          </Scrollbar>
        </Box>
      </Scrollbar>
    </RootStyle>
  );
}
